import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ReactComponent as ChevronDownIcon } from '../../assets/images/svg/chevron-down.svg';
import themeColors from '../../assets/styles/themeColors';

const ChevronDownIconStyled = styled(ChevronDownIcon)`
  width: ${({ w }) => w};
  height: ${({ h }) => h};
  stroke: ${({ color }) => color || themeColors.colorTextSecondary};
`;

const ChevronDown = (props) => <ChevronDownIconStyled {...props} />;

ChevronDown.propTypes = {
  w: PropTypes.string,
  h: PropTypes.string,
  color: PropTypes.string,
};

ChevronDown.defaultProps = {
  w: '25px',
  h: '24px',
};

export default ChevronDown;
